<template>
  <b-card-actions action-collapse title="Quotations list">
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <!-- <label class="mr-1">Search</label> -->
            <b-form-input
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
          </div>
        </b-form-group>
      </div>
    </div>

    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
      ref="table-quote"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
      class="quote-table"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
            
              <b-dropdown-item v-if="props.row.state!=='accepted'" @click="acceptQuote(props.row._id)">
                <feather-icon icon="CheckIcon" class="mr-50" />
                <span>Accept quote</span>
              </b-dropdown-item>

              <b-dropdown-item v-if="props.row.state!=='refused'" @click="refuseQuote(props.row._id)">
                <feather-icon icon="XIcon" class="mr-50" />
                <span>Refuse quote</span>
              </b-dropdown-item>

              <b-dropdown-item @click="UpdateQuote(props.row._id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Update quote</span>
              </b-dropdown-item>

              <b-dropdown-item @click="DeleteQuote(props.row._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete quote</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <span v-else-if="props.column.field == 'customer'">
        <p v-if="props.row.customer">{{ props.row.customer.email }} <br> {{ props.row.customer.customer.firstName }} {{ props.row.customer.customer.lastName }}</p>
      </span>
      <span v-else-if="props.column.field == 'state'">
        <p v-if="props.row.state=='accepted'">  
          <b-badge variant="success">
        Accepted
        </b-badge>
        </p>
        <p v-if="props.row.state=='refused'">
            <b-badge variant="danger">
        Refused
      </b-badge>
        </p>
        <p v-if="props.row.state=='pending'">  <b-badge variant="warning">
        Pending
        </b-badge></p>

      </span>
      <span v-else-if="props.column.field == 'containers'">
        <table>
          <tr>
            <th>Type</th>
            <th>Quantity</th>
            <th>Weight</th>
            <th>Shipper owned container</th>
          </tr>
          <tr v-for="(container, index) in props.row.containers" :key="index">
            <td>{{ container.containerType }}</td>
            <td>{{ container.quantity }}</td>
            <td>{{ container.weight }}KG</td>
            <td v-if="container.isOwnedByShipper">SOC</td>
            <td v-else>COC</td>
          </tr>
        </table>
      </span>
      <span v-else-if="props.column.field == 'pdf'">
        <div class="file">
          <b-form-file
            placeholder ="PDF"
            type="file"
            v-model="file"
            name="file"
            accept=".pdf"
          ></b-form-file>
          <b-button size="sm" variant="gradient-primary" class="file-button" @click="uploadFile(props.row._id)">
            <feather-icon icon="SaveIcon" size="18"/>
          </b-button>
        </div>
        <b-button size="sm" class="mt-1 f-right" v-if="props.row.pdf" @click="downloadFile(props.row.pdf)"> <feather-icon icon="DownloadIcon" size="18"/></b-button>
      </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['5', '10', '15']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  
  </b-card-actions>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BImg,
  BModal,
  VBModal,
  BForm,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BFormFile,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";
import moment from "moment";
import { BBadge } from "bootstrap-vue";

export default {
  components: {
    BBadge,
    BDropdown,
    BDropdownItem,
    BTooltip,
    BModal,
    VBModal,
    BForm,
    BImg,
    BButton,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BFormFile,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      file: null,
      show: false,
      pageLength: 5,
      pageLengthModal: 5,
      dir: false,

      columns: [
        {
          label: "Action",
          field: "action",
          sortable: false,
        },
        {
          label: "State",
          field: "state",
          filterOptions: {
            enabled: true,
            placeholder: "State",
          },
        },
         {
          width: "300px",
          label: "Quotation",
          field: "pdf",
        },
        {
          width: "200px",
          label: "Customer",
          field: "customer",
          filterOptions: {
            enabled: true,
            placeholder: "Customer",
          },
        },
        {
          width: "200px",
          label: "Reference",
          field: "reference",
          filterOptions: {
            enabled: true,
            placeholder: "Reference",
          },
        },
        {
          width: "160px",
          label: "Loading Port",
          field: "loadingPort",
          filterOptions: {
            enabled: true,
            placeholder: "Loading Port",
          },
        },
        {
          width: "170px",
          label: "Discharge Port",
          field: "dischargePort",
          filterOptions: {
            enabled: true,
            placeholder: "Discharge Port",
          },
        },
        {
          label: "Incoterm",
          field: "incoterm",
          filterOptions: {
            enabled: true,
            placeholder: "Incoterm",
          },
        },
        {
          label: "Transport",
          field: "transportType",
          filterOptions: {
            enabled: true,
            placeholder: "Transport",
          },
        },
        {
          width: "200px",
          label: "Address Arrival city",
          field: "arrivalAddressCity",
          filterOptions: {
            enabled: true,
            placeholder: "Address Arrival city",
          },
        },
        {
          width: "230px",
          label: "Address departure city",
          field: "departureAddressCity",
          filterOptions: {
            enabled: true,
            placeholder: "Address departure city",
          },
        },
        {
          label: "Commodity",
          field: "commodity",
          filterOptions: {
            enabled: true,
            placeholder: "Commodity",
          },
        },
        /*{
          label: "Temperature Control",
          field: "requiresTemperatureControl",
          filterOptions: {
            enabled: true,
            placeholder: "Temperature Control",
          },
        },
        {
          label: "Temperature",
          field: "TemperatureControl",
          filterOptions: {
            enabled: true,
            placeholder: "Temperature",
          },
        },*/
        {
          width: "200px",
          label: "Special Equipment",
          field: "requiresSpecialEquipment",
          filterOptions: {
            enabled: true,
            placeholder: "Special Equipment",
          },
        },
        {
          label: "Height",
          field: "specialEquipment.height",
          filterOptions: {
            enabled: true,
            placeholder: "Height",
          },
        },
        {
          label: "Width",
          field: "specialEquipment.width",
          filterOptions: {
            enabled: true,
            placeholder: "Width",
          },
        },
        {
          label: "Length",
          field: "specialEquipment.length",
          filterOptions: {
            enabled: true,
            placeholder: "Length",
          },
        },
        {
          width: "190px",
          label: "Dangerous Cargo",
          field: "dangerousCargo",
          filterOptions: {
            enabled: true,
            placeholder: "Dangerous Cargo",
          },
        },
        {
          label: "Classe",
          field: "commodityClass",
          filterOptions: {
            enabled: true,
            placeholder: "Classe",
          },
        },
        {
          label: "Un",
          field: "commodityUn",
          filterOptions: {
            enabled: true,
            placeholder: "Un",
          },
        },
        {
          label: "Containers",
          field: "containers",
          filterOptions: {
            enabled: true,
            placeholder: "Containers",
          },
        },
        {
          width: "190px",
          label: "Effective Date",
          field: "effectiveDate",
          filterOptions: {
            enabled: true,
            placeholder: "Effective Date",
          },
          formatFn: (value) => {
            return moment(value).format("MM/DD/YYYY");
          },
        },
        {
          width: "190px",
          label: "Expiry Date",
          field: "expiryDate",
          filterOptions: {
            enabled: true,
            placeholder: "Expiry Date",
          },
          formatFn: (value) => {
            return moment(value).format("MM/DD/YYYY");
          },
        }
      ],
      rows: [],
      rowModal: [],
      searchTerm: "",
    };
  },
  watch: {
    "$route.query.id": "getAllDataQuote",
  },
  async created() {
    await this.getAllDataQuote();
  },
  methods: {
    advanceSearch(val) {
      this.searchTerm = val;
    },
    async getAllDataQuote() {
      if (this.$route.query.id) {
        await axios
          .get(
            "https://mtl-feeder-nodejs.onrender.com/api/quotations?user=" +
              this.$route.query.id
          )
          .then((response) => {
            this.rows = response.data.data.reverse();
          })
          .catch((error) => {
            this.errorMessage = error.message;
          });
      } else {
        await axios
          .get("https://mtl-feeder-nodejs.onrender.com/api/quotations")
          .then((response) => {
            this.rows = response.data.data.reverse();
          })
          .catch((error) => {
            this.errorMessage = error.message;
          });
      }
    },
    async uploadFile(id) {
      if (!this.file) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Please select a file`,
            icon: "UserIcon",
            variant: "warning",
          },
        });
      } else {
        const allowedExtensions = [".pdf"];
        const fileExtension = this.file.name.slice(
          this.file.name.lastIndexOf(".")
        );
        if (!allowedExtensions.includes(fileExtension)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `PDF file only`,
              icon: "UserIcon",
              variant: "warning",
            },
          });
        } else {
          const formData = new FormData();
          formData.append("pdf", this.file);
          try {
            const response = await axios.put(
              `https://mtl-feeder-nodejs.onrender.com/api/quotations/${id}`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            this.getAllDataQuote();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `File submitted`,
                icon: "UserIcon",
                variant: "success",
              },
            });
          } catch (error) {
            console.error(error);
          }
        }
      }
    },
    downloadFile(url) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "File.pdf";
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    DeleteQuote(id) {
      this.$swal({
        title: "You really want to delete this quote ?",
        text: "You can't undo this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm !",
        cancelButtonText: "Cancel !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios
            .put(
              `https://mtl-feeder-nodejs.onrender.com/api/quotations/${id}`,
              { active: false }
            )
            .then((response) => {
              this.getAllDataQuote();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Quote is deleted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Error while deleting`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action canceled",
            icon: "error",
            confirmButtonText: "Close !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    UpdateQuote(id) {
      var routerLink = "/sale/quotations/edit?id=" + id;
      this.$router.replace(routerLink);
    },
    acceptQuote(id) {
      axios
        .put(`https://mtl-feeder-nodejs.onrender.com/api/quotations/${id}`, {
          state: "accepted",
        })
        .then((response) => {
          this.getAllDataQuote();
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Error while updating`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
        });
    },
    refuseQuote(id) {
      axios
        .put(`https://mtl-feeder-nodejs.onrender.com/api/quotations/${id}`, {
          state: "refused",
        })
        .then((response) => {
          this.getAllDataQuote();
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Error while updating`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style>
.quote-table .vgt-table.bordered td {
  text-align: center;
  vertical-align: middle !important;
}
.quote-table .vgt-table.bordered td:last-child {
  text-align: left;
}
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}
.btn-delete-all {
  margin-left: 3%;
}

.p-description {
  height: 60px;
  width: 250px;
  overflow: auto;
}
.barcode-size svg {
  height: 80px;
}
.file {
  display: flex;
  align-items: center;
}
.file-button {
  margin-left: 10px;
}
</style>
